<template>
  <div class="list-header">
    <div class="header">
      <div class="header-title">{{titleData}}</div>
      <div class="header-tab" v-if="showTab">
        <div class="tab" :class="{'active all': optionTabData === 'all'}" @click="onOptionTabClick('all')">全部</div>
        <div class="tab" :class="{'active positive': optionTabData === 'positive'}" @click="onOptionTabClick('positive')">正面</div>
        <div class="tab" :class="{'active negative': optionTabData === 'negative'}" @click="onOptionTabClick('negative')">负面</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titleData: '',
      optionTabData: 'all',
      showTab: false
    };
  },
  props: {
    title: {
      type: String
    },
    optionTab: {
      type: String,
      default: 'all'
    },
    isShowTab: {
      type: Boolean
    }
  },
  watch: {
    optionTab(val) {
      this.optionTabData = val;
    }
  },
  methods: {
    onOptionTabClick(optionTab) {
      this.optionTabData = optionTab;
      this.$emit('change', optionTab);
    }
  },
  mounted() {
    this.titleData = this.title;
    this.optionTabData = this.optionTab;
    this.showTab = this.isShowTab;
  }
};
</script>

<style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
    height: 48px;
    line-height: 48px;
    color: rgba(255, 255, 255, 0.8);
    background-color: #4a484f;
    font-size: 14px;
    .header-tab {
      display: flex;
      .tab {
        padding-left: 16px;
        cursor: pointer;
        &:hover {
          color: #ffffff;
        }
      }
      .active {
        position: relative;
        color: #ffffff;
      }
      .active::after {
        content: '';
        position: absolute;
        top: 46px;
        right: 0;
        width: 28px;
        height: 2px;
        
      }

      .all::after {
        background-color: #45a8cc;
      }

      .positive::after {
        background-color: #ff5b65;
      }

      .negative::after {
        background-color: #6eecb9;
      }
    }
  }
</style>

